export default {
  init($) {
    // JavaScript to be fired on the about page
  },
  finalize($){
    {
      $('.tab-content').hide();
      $('.tab-content:first').show();
      $('.tabs .wrap-logo').on( "click", function(){
        let tab_id = $(this).attr('data-tab');
        //$('.tabs .wrap-logo').removeClass('active');
        $('.tab-content').hide();
        //$(this).addClass('active');
        $(tab_id).show();
      });
    }
    {
      $(".accordion-title").on("click", function() {
        if ($(this).hasClass("active")) {
          $(this).removeClass("active");
          $(this)
            .siblings(".accordion-content")
            .slideUp(200);
        } else {
          $(".accordion-title").removeClass("active");
          $(this).addClass("active");
          $(".accordion-content").slideUp(200);
          $(this)
            .siblings(".accordion-content")
            .slideDown(200);
        }
      });
    }
  }
};
